export default __webpack_public_path__ + "static/valuation-img-7a894055797e48588d518e2f6ab8acef.jpg";